<template>
  <div class="modal" @click.self="cancel">
    <div v-if="sections.length > 0" class="modal-container">
      <header>{{ __('Pick a section to post to') }}</header>
      <div class="list modal-list">
        <div
          v-for="section in sections"
          :key="section.id"
          class="list-item is-actionable big-body-type"
          @click="pick(section.id)"
        >
          <div class="list-item-primary">
            {{ section.title }}
          </div>
        </div>
      </div>
    </div>
    <div v-else class="modal-container">
      <header>{{ __('You have not created any sections yet') }}</header>
      <div class="modal-body">{{ __('Create a section before posting.') }}</div>
      <footer class="button-list">
        <button class="text-button" @click="cancel">{{ __('Okay') }}</button>
      </footer>
    </div>
  </div>
</template>

<script>
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import EscapeToCancelMixin from 'vuemixins/escape_to_cancel_mixin'
import { mapGetters, mapActions } from 'vuex'

export default {
  mixins: [EscapeToCancelMixin],
  computed: {
    ...mapGetters('section', {
      wallSections: 'sortedSections',
    }),
    sections() {
      return this.wallSections.filter((x) => x.created_at)
    },
  },
  methods: {
    ...mapActions('post', ['pickSection', 'cancelPickingSection']),
    pick(sectionId) {
      this.pickSection({ sectionId })
    },
    cancel() {
      this.cancelPickingSection()
    },
  },
}
</script>
